import {styled} from "@mui/material/styles"

export const StandardViewAllWrapper = styled("div")`
    && {
        display: flex;
        align-items: center;
        background-color: ${({theme}) => theme.colours.popover.header.backgroundColour};
        min-height: 2.75rem;
        padding: 0 1rem;
    }
`

export default StandardViewAllWrapper
